import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectShouldDisplayFilters } from '../../store/geoentity/filter.selectors'
import { focusGeoentity } from '../../store/geoentity/geoentity.actions'
import { selectCurrentGeoentityId } from '../../store/geoentity/geoentity.selectors'
import { unfocusGeoentity } from '../../store/geoentity/geoentitySlice'
import {
  isAddressRoute,
  selectCurrentHistoryRoute,
  selectCurrentHistoryRouteOptions
} from '../../store/history/history.selectors'
import { isGE } from '../Device'
import { PUB_TAG } from '../analytics/PublisherTagsService'
import { useScrollContext } from '../genericComponents/ResponsiveScrollableWrapper/ResponsiveScrollableWrapper'
import { PREHEADER_HEIGHT } from '../header/header-constants'
import useComputedHeaderHeight from '../ui/useHeaderHeight'
import { getPoiImageAlt, getPoiReservationLink, RESERVATION_URL_TYPE_LIST } from '../utils/geoentity'
import { useAction } from '../utils/react-redux'
import useEventCallback from '../utils/useEventCallback'
import s from './GeoentityListItem.less'
import useCommonGeoentityClickTagProps from './useCommonGeoentityClickTagProps'

const useContextPoiDisplayOptions = () => {
  const route = useSelector(selectCurrentHistoryRoute)
  const defaultDisplay = {
    address: true,
    rubric: false
  }
  if (isAddressRoute(route))
    return {
      ...defaultDisplay,
      address: false,
      rubric: true
    }
  return defaultDisplay
}

const useLiMouseListeners = ({ id }) => {
  const dispatch = useDispatch()
  const execFocusGeoentity = useAction(focusGeoentity)

  const onMouseEnter = useEventCallback(() => execFocusGeoentity(id), [execFocusGeoentity, id])
  const onMouseLeave = useEventCallback(() => dispatch(unfocusGeoentity()), [])

  return isGE()
    ? {
        onMouseEnter,
        onMouseLeave
      }
    : {}
}

const useGeoentityListItem = poi => {
  const { id: poiId } = poi
  const scrollContext = useScrollContext()
  const reservationUrl = getPoiReservationLink(poi, RESERVATION_URL_TYPE_LIST)

  const displayOptions = useContextPoiDisplayOptions()
  const clickTagPropsForRedirection = useCommonGeoentityClickTagProps(
    PUB_TAG.PUB_LISTEREPONSE_REDIRECTIONRESERVATION,
    poi
  )

  const geoentityImageAlt = getPoiImageAlt(poi)
  const currentGeoentityId = useSelector(selectCurrentGeoentityId)

  const liMouseListeners = useLiMouseListeners({ id: poiId })
  const { scrollTop } = useSelector(selectCurrentHistoryRouteOptions)
  const shouldDisplayFilters = useSelector(selectShouldDisplayFilters)
  const computedHeaderHeight = useComputedHeaderHeight(false, shouldDisplayFilters) + PREHEADER_HEIGHT

  const isSelected = poiId === currentGeoentityId

  useEffect(() => {
    if (isGE() && isSelected) {
      const selectedElement = document.querySelector(`li.${s.selectedItem}`)

      if (scrollTop && selectedElement?.getBoundingClientRect) {
        scrollContext.scrollTo(
          selectedElement.getBoundingClientRect().top + scrollContext.getScrollValue() - computedHeaderHeight
        )
      }
    }
  }, [isSelected, computedHeaderHeight])

  return {
    reservationUrl,
    displayOptions,
    clickTagPropsForRedirection,
    geoentityImageAlt,
    liMouseListeners,
    isSelected
  }
}

export default useGeoentityListItem
